import React from "react";
import AppRouter from './AppRouter'
import DynamicSitemap from "react-dynamic-sitemap";

export default function Sitemap(props) {
	return (
		<DynamicSitemap routes={AppRouter} prettify={true} {...props}/>
	);
}